import { render, staticRenderFns } from "./ResultRequestsPage.vue?vue&type=template&id=b1565aa2&"
import script from "./ResultRequestsPage.vue?vue&type=script&lang=js&"
export * from "./ResultRequestsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports